import React from 'react';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import StyledTableCell from './StyledTableCell';

const TableHeader = ({ columns = [] }) => {
	return (
		<TableHead>
			<TableRow>
				{columns.map((col, i) => (
					<StyledTableCell key={i} align={col.align}>
						{col.label}
					</StyledTableCell>
				))}
			</TableRow>
		</TableHead>
	);
};

export default TableHeader;
